import { ALL_MEETINGS_TAB } from '../../screens/Meetings/EventMeetingsTabbed/tabs';

/**
 * Return the URL for a meeting.
 *
 * @param {Number} eventId - The id of the event containing the meeting.
 * @param {Number} meetingId - The id of the meeting.
 * @param {String} [defaultTab=ALL_MEETINGS_TAB] - The tab to open in the meeting list.
 *
 * @returns {String} The URL of the meeting.
 */
export function getMeetingURL(eventId, meetingId, defaultTab = ALL_MEETINGS_TAB) {
    return ['/events', eventId, 'meetings', defaultTab, meetingId].join('/');
}
